import React from 'react';
import TextField from '@mui/material/TextField';
import { InputAdornment } from '@mui/material';
import ApartmentIcon from '@mui/icons-material/Apartment';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export function CNPJ(props) {

    return (
        <div>
            <div className={`${props.steps === 0 ? 'flex flex-col gap-4' : 'hidden'}`}>
                <div className='text-2xl'>Entrar</div>
                <TextField
                    onKeyDown={props.handleEnter}
                    value={props.cnpjMask(props.cnpj)}
                    onChange={(e) => props.setCnpj(e.target.value)}
                    onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                            e.preventDefault()
                        }
                    }}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <ApartmentIcon color='primary' />
                            </InputAdornment>
                        ),
                    }}
                    className={props.styles.CNPJ}
                    id="outlined-basic cnpj"
                    label="CPF/CNPJ de acesso"
                    variant="standard"
                    helperText="Informe somente números"
                    focused
                />
            </div>

            <div
                className={`${props.steps === 1 ? 'flex' : 'hidden'} text-lg text-gray-700 flex flex-row items-center gap-[0.3rem]`}
                onClick={() => {
                    props.setSteps(0)
                    props.setIsPrimeiroAcesso(false)
                }}
            >
                <div
                    className='hover:bg-gray-100 hover:rounded-full cursor-pointer'
                >
                    <ArrowBackIcon color='action' />
                </div>
                {props.cnpjMask(props.cnpj)}
            </div>
        </div>
    )

}